import request from '../utils/request';

//添加加盟商
export function addBusiness(data) {
    return request({
        url: 'home/city/add_business',
        method: 'post',
        data: data,
    });
}
//添加加盟商
export function delBusiness(data) {
    return request({
        url: 'home/city/del_business',
        method: 'post',
        data: data,
    });
}
//代理商类别
export function spaceType(data) {
    return request({
        url: 'home/spacecate/list',
        method: 'post',
        data: data,
    });
}
//代理商类别
export function editBusiness(data) {
    return request({
        url: 'home/city/edit_business',
        method: 'post',
        data: data,
    });
}
